import { render, staticRenderFns } from "./ReportSalesSumsPerCustomerPage.vue?vue&type=template&id=0f2f91d2&scoped=true"
import script from "./ReportSalesSumsPerCustomerPage.vue?vue&type=script&lang=js"
export * from "./ReportSalesSumsPerCustomerPage.vue?vue&type=script&lang=js"
import style0 from "./ReportSalesSumsPerCustomerPage.vue?vue&type=style&index=0&id=0f2f91d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2f91d2",
  null
  
)

export default component.exports